import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import Grid from '@material-ui/core/Grid';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import Button from '@material-ui/core/Button';
import { Typography, MenuItem, Hidden, TextField, Divider, Link, TableRow, FormHelperText } from '@material-ui/core';
import { genfunction } from '../../../helpers';
import { NumberSpinner } from '../../../components/InputControls';
import ReactHtmlParser from 'react-html-parser';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Moment from 'moment';
import Select from '@material-ui/core/Select';

import InputLabel from '@material-ui/core/InputLabel';


import {
    actionUpdateMembershipPackage, actionDeleteMembershipTypePerson, actionUpdateMembershipAddonsQuantity,
    actionUpdateFamilyMemberNotPartOfPackage, actionUpdatePackageForRenew, actionResetMembershipPackage
} from 'actions';
import { actionShopCartAddMembershipPackage } from 'actions';
import { actionGetCountryAndState, actionResetCountryAndState } from 'actions';
import { useDispatch, useSelector } from 'react-redux';
import CancelIcon from '@material-ui/icons/Cancel';
import EditIcon from '@material-ui/icons/Edit';
import ErrorHandling from '../../../components/ErrorHandling/ErrorHandling';
import { FormControl } from '@material-ui/core';
import { actionSetFieldValueState, actionResetFieldValuesState } from 'actions';
import DialogeBox from '../../../components/DialogeBox/DialogeBox';
import { Table, TableBody, TableCell, TableHead } from '@material-ui/core';
import { actionResetMemberValidation } from 'actions';
import Checkbox from '@material-ui/core/Checkbox';
import MaskedInput from 'react-text-mask';
import MembershipUDF from '../../../components/UDFs/MembershipUDF';
import { actionGetMembershipUserDefinedFields, actionUpdateMembershipUdfsWithCustomerUdfsValues, actionResetMembershipUDFs } from 'actions';
import { actionResetCustomerUdfs } from 'actions';

import { Autocomplete } from '@material-ui/lab';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';

const { AddPersonFirstNameLength, AddPersonLastNameLength, AddPersonEmailLength, AddPersonDOBLength, AddPersonZipCodeLength, AddPersonCityLength,
    AddPersonStateLength, AddPersonCountryLength, AddPersonAddress1Length, AddPersonAddress2Length, DOBRegex, EmailRegex, ValidateMembershipMinQuantity,
    TryDeletePrimaryRecordOnMembership, ConfirmMsgRemovePersonFromMemberPackage, DisplayMemPackageDiscriptionCharacters, PackageDiscriptionHeading,
    ValidateMembershipMaxQuantity, PackageMaxQtyMsg, PackageMinQtyMsg, OrderItemsInCartError
} = window['runConfig'];


const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3)
    },
    primarycolor: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    mainHeading: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary
    },
    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        minHeight: '40px',
        maxHeight: '70px'
    },
    dialogTitleHeader: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        height: '50px'
    },
    smalltourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        minHeight: '25px',
        maxHeight: '60px'
    },
    hr: {
        display: 'block',
        height: '1px',
        border: 0,
        borderTop: '1px solid #ccc',
        padding: 0
    },
    displaynone: {
        display: "none"
    },
    visible: {
        visibility: "visible"
    },
    box100per: {
        width: "100%"
    },
    AddHoverOnIcons: {
        cursor: "pointer !important"
    },
    tablecell: {
        padding: "5px"
    },
    errorColor: {
        color: 'red !mportant'
    },
    defaultColor: {
        color: theme.palette.text.secondary
    },
    udfWidth: {

        minWidth: 300,

    },
    clearButton: {
        "& .MuiButtonBase-root.MuiAutocomplete-clearIndicator": {
            color: theme.palette.primary.main

        }
    }

}));

function TextMaskCustom(props) {
    const { inputRef, onChange, value, ...other } = props;
    let pnMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    return (
        <MaskedInput
            value={value}
            {...other}
            ref={(ref) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            onChange={onChange}
            mask={pnMask}
        />
    );
}

export default function MembershipTypes(props) {

    let memberPackage;
    let usersnotpartofpackage;
    const dispatch = useDispatch();


    const membershippackagesreducer = useSelector(state => state.reducerMembershipPackages);
    const orderProducts = useSelector(state => state.reducerShopCart.orderProducts);
    memberPackage = membershippackagesreducer.membershipPackage;
    usersnotpartofpackage = membershippackagesreducer.familymembersnotpartofPackage;
    const membermemberhisps = useSelector(state => state.reducerMemberMemberships);
    const memberValidationReducer = useSelector(state => state.reducerMemberValidation);
    const [isredirectclicked, setisredirectclicked] = useState(false);
    const memmemberhisps = useSelector(state => state.reducerMemberMemberships);
    const customer = useSelector(state => state.reducerCustomer);
    const membershipTypesUdfs = useSelector(state => state.reducerMembershipUserDefinedFields);
    const customerUdfs = useSelector(state => state.reducerCustomerUDFs);
    const shopcartMembershipPackage = useSelector(state => state.reducerShopCart.MembershipPackages);
    const countryandstates = useSelector(state => state.reducerCountryAndState.countryandstate);


    //Intialize States
    const [errorstate, seterrorstate] = React.useState({
        initialerrorstate: {
            first_name: {
                errorstate: false,
                errortext: ""
            },
            last_name: {
                errorstate: false,
                errortext: ""
            },
            email: {
                errorstate: false,
                errortext: ""
            },
            membershipType: {
                errorstate: false,
                errortext: ""
            },
            age: {
                errorstate: false,
                errortext: ""
            },
            address1: {
                errorstate: false,
                errortext: ""
            },
            city: {
                errorstate: false,
                errortext: ""
            },
            state: {
                errorstate: false,
                errortext: ""
            },
            zipcode: {
                errorstate: false,
                errortext: ""
            },
            country: {
                errorstate: false,
                errortext: ""
            }
        }
    });

    const filterOptions = createFilterOptions({
        stringify: (option) => option.Country + '' + option.State,
    });

    const [state, setState] = React.useState({
        memberpackageDetail: {
            popupTitle: 'Add Person',
            isPrimaryMember: false,
            firstName: '',
            lastName: '',
            email: '',
            dob: '',
            phone: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            zipcode: '',
            country: '',
            membershipPackageID: props.membershipPackage.hasOwnProperty("MembershipPackageID") ? props.membershipPackage.MembershipPackageID : 0,
            membershipTypeID: 0,
            membershipTypeName: '',
            isRenewal: false,
            userNo: Math.floor((Math.random() * 100000) + 100000),// 0,
            isEdit: false,
            UniquePackageRef: '',
            MembershipExpiryDate: '',
            PreviousMembershipType: '',
            notPartOfPackage: false
        }
    });

    window.history.pushState({ name: "browserBack" }, "on browser back click", window.location.href);

    useEffect(() => {

        if (props.isRenewPackage && usersnotpartofpackage && usersnotpartofpackage.length == 0) {
            setopenMembership(true);
        }

    }, [props.isRenewPackage])

    useEffect(() => {
        if (countryandstates === undefined || countryandstates.length == 0)
            actionGetCountryAndState(dispatch);

    }, [])

    const onChangeCountry = (event, value) => {
        var memberpackageDetail = { ...state.memberpackageDetail };

        memberpackageDetail.country = (value === null ? '' : value.Country);
        setState({ ...state, memberpackageDetail: memberpackageDetail })
        actionSetFieldValueState(dispatch, "country", memberpackageDetail.country);

        memberpackageDetail.state = "";
        setState({ ...state, memberpackageDetail: memberpackageDetail });
        actionSetFieldValueState(dispatch, "state", "");

    }
    const onChangeState = (event, value) => {
        var memberpackageDetail = { ...state.memberpackageDetail };

        memberpackageDetail.state = value === null ? "" : value.State
        setState({ ...state, memberpackageDetail: memberpackageDetail });
        actionSetFieldValueState(dispatch, "state", memberpackageDetail.state);

    }

    const handleCloseMembership = () => {
        var memberpackageDetail = { ...state.memberpackageDetail };

        if (memberpackageDetail.isPrimaryMember && !memberpackageDetail.isEdit) {

            props.history.push({
                pathname: '/memberships'
            })
        }
        else {
            setOpen(false);
        }
    };

    useEffect(() => {

        if (!props.shopcartmember) {
            handleClickOpen();
            var memberpackageDetail = { ...state.memberpackageDetail };
            memberpackageDetail.isPrimaryMember = true;
            memberpackageDetail.popupTitle = "Primary Member";
            memberpackageDetail.country = countryandstates && countryandstates.length > 0 ? countryandstates[0].Country : '';
            setState({ ...state, memberpackageDetail: memberpackageDetail })
        }
        else {
            actionUpdateMembershipPackage(dispatch, props.membershipPackage, true);
            memberPackage = props.membershipPackage;
        }


        if (props.isRenewPackage) {

            props.membershipPackage.MembershipProducts && props.membershipPackage.MembershipProducts.map(e => {

                if (e.MembershipType === "Membership" && e.Users.length > 0) {

                    e.Users.map(u => {
                        if (u.isPrimaryMember) {
                            actionSetFieldValueState(dispatch, "first_name", u.firstName === undefined ? '' : u.firstName);
                            actionSetFieldValueState(dispatch, "last_name", u.lastName === undefined ? '' : u.lastName);
                            actionSetFieldValueState(dispatch, "email", u.email === undefined ? '' : u.email);
                            actionSetFieldValueState(dispatch, "phone_number", u.phone === undefined ? '' : u.phone);
                            actionSetFieldValueState(dispatch, "address1", u.address1 === undefined ? '' : u.address1);
                            actionSetFieldValueState(dispatch, "address2", u.address2 === undefined ? '' : u.address2);
                            actionSetFieldValueState(dispatch, "city", u.city === undefined ? '' : u.city);
                            actionSetFieldValueState(dispatch, "state", u.state === undefined ? '' : u.state);
                            actionSetFieldValueState(dispatch, "zip", u.zipcode === undefined ? '' : u.zipcode);
                            actionSetFieldValueState(dispatch, "country", u.country === undefined ? '' : u.country);

                        }
                    });
                }
            });
        }

        //actionGetMembershipUserDefinedFields(dispatch, 'Memberships', null, GetMembershipTypes());
    }, []);

    //props

    useEffect(() => {

        if (props.membershipTypeIDs && props.membershipTypeIDs.length > 0 && membershipTypesUdfs.membershipUdfs && membershipTypesUdfs.membershipUdfs.length < 1)
            actionGetMembershipUserDefinedFields(dispatch, 'Memberships', null, props.membershipTypeIDs);
    }, [props.membershipTypeIDs]);

    let [membershipUdfsUpdated, setmembershipUdfsUpdated] = React.useState(0);

    useEffect(() => {

        if (membershipUdfsUpdated == 0 && customerUdfs.customerUDFs && customerUdfs.customerUDFs.length > 0 && membershipTypesUdfs.membershipUdfs && membershipTypesUdfs.membershipUdfs.length > 0 && CountTotalMembers() > 0) {
            actionUpdateMembershipUdfsWithCustomerUdfsValues(dispatch, props.membershipPackage, customerUdfs.customerUDFs);
            setmembershipUdfsUpdated(setmembershipUdfsUpdated++);
        }

    }, [setmembershipUdfsUpdated, membershipTypesUdfs.membershipUdfs]);

    //Dialog Fields Start
    const [open, setOpen] = React.useState(false);

    //Dialog Membership  Start
    const [openMembership, setopenMembership] = React.useState(false);

    //Confirmation Dialog
    const [confirmopen, setconfirmOpen] = React.useState({
        dialogBox: false,
        packageID: 0,
        memTypeID: 0,
        useNo: 0,
        deletemsg: ''
    });


    const handleClickOpen = () => {

        var memberpackageDetail = { ...state.memberpackageDetail };

        memberpackageDetail.popupTitle = 'Add Person';
        memberpackageDetail.isPrimaryMember = false;
        memberpackageDetail.firstName = '';
        memberpackageDetail.lastName = '';
        memberpackageDetail.email = '';
        memberpackageDetail.dob = 'DOB';
        memberpackageDetail.phone = '';
        memberpackageDetail.address1 = '';
        memberpackageDetail.address2 = '';
        memberpackageDetail.city = '';
        memberpackageDetail.state = '';
        memberpackageDetail.zipcode = '';
        memberpackageDetail.country = '';
        memberpackageDetail.MembershipPackageID = props.membershipPackage.hasOwnProperty("MembershipPackageID") ? props.membershipPackage.MembershipPackageID : 0;
        memberpackageDetail.membershipTypeID = 0;
        memberpackageDetail.membershipTypeName = '';
        memberpackageDetail.PreviousMembershipType = '';
        memberpackageDetail.isEdit = false;
        memberpackageDetail.userNo = Math.floor((Math.random() * 100000) + 100000); //0;
        memberpackageDetail.MembershipTypeID = 0;
        memberpackageDetail.notPartOfPackage = false;

        setState({ ...state, memberpackageDetail: memberpackageDetail })

        var initialerrorstate = { ...errorstate.initialerrorstate };

        initialerrorstate.first_name.errorstate = false;
        initialerrorstate.first_name.errortext = "";
        initialerrorstate.last_name.errorstate = false;
        initialerrorstate.last_name.errortext = "";
        initialerrorstate.email.errorstate = false;
        initialerrorstate.email.errortext = "";
        initialerrorstate.membershipType.errorstate = false;
        initialerrorstate.membershipType.errortext = "";
        initialerrorstate.age.errorstate = false;
        initialerrorstate.age.errortext = "";

        seterrorstate({ ...errorstate, initialerrorstate });

        setOpen(true);

    };

    useEffect(() => {

        var memberpackageDetail = { ...state.memberpackageDetail };
        if (memberpackageDetail && !memberpackageDetail.isEdit &&
            memberpackageDetail.membershipTypeID < 1
            && props.membershipPackage
            && (memberpackageDetail.popupTitle === 'Add Person' || memberpackageDetail.popupTitle === 'Add - Person' || memberpackageDetail.popupTitle === 'Primary Member')) {

            if (props.membershipPackage.MembershipProducts
                && props.membershipPackage.MembershipProducts.filter(x => x.MembershipType === "Membership").length == 1) {
                let membershipObj = props.membershipPackage.MembershipProducts.filter(x => x.MembershipType === "Membership")[0];
                fieldhandleChange(null, membershipObj);
            }
        }

    }, [props.membershipPackage, state])

    const handleClose = (event, reason) => {

        if (reason === "backdropClick" || reason === "escapeKeyDown") {
            setOpen(true);
        }
        else {

            var memberpackageDetail = { ...state.memberpackageDetail };
            if (memberpackageDetail.isPrimaryMember && !memberpackageDetail.isEdit) {

                if (shopcartMembershipPackage && shopcartMembershipPackage.length < 1 &&
                    membershipTypesUdfs.membershipUdfs && membershipTypesUdfs.membershipUdfs.length > 0) {

                    actionResetMembershipUDFs(dispatch);
                }

                actionResetMembershipPackage(dispatch);
                props.history.push({
                    pathname: '/memberships'
                })
            }
            else {
                setOpen(false);
            }
        }
    };

    const GetUserDOB = (user) => {
        let userDOB = "";

        if (user.hasOwnProperty('dob') && user.dob.length > 0 && user.dob != "DOB") {
            userDOB = Moment(user.dob).format('YYYY-MM-DD');
        }

        return userDOB;
    }
    //Edit Person
    const EditPerson = (member, memTypeID) => {

        var memberpackageDetail = { ...state.memberpackageDetail };
        var membershipType = memberPackage.MembershipProducts.filter(x => x.MembershipTypeID == memTypeID)[0];

        if (membershipType) {
            var user = membershipType.Users.filter(x => x.userNo == member.userNo && x.email == member.email)[0];
            if (user) {
                memberpackageDetail.popupTitle = user.isPrimaryMember ? 'Edit - Primary Member' : 'Edit - Person';
                memberpackageDetail.isPrimaryMember = user.isPrimaryMember;
                memberpackageDetail.firstName = user.firstName;
                memberpackageDetail.lastName = user.lastName;
                memberpackageDetail.email = user.email;
                memberpackageDetail.dob = GetUserDOB(user);
                memberpackageDetail.phone = user.phone;
                memberpackageDetail.address1 = user.address1;
                memberpackageDetail.address2 = user.address2;
                memberpackageDetail.city = user.city;
                memberpackageDetail.state = user.state;
                memberpackageDetail.zipcode = user.zipcode;
                memberpackageDetail.country = user.country;
                memberpackageDetail.isRenewal = user.isRenewal;
                memberpackageDetail.UniquePackageRef = user.UniquePackageRef;
                memberpackageDetail.MembershipExpiryDate = user.MembershipExpiryDate;
                memberpackageDetail.MembershipPackageID = memberPackage.MembershipPackageID;
                memberpackageDetail.membershipTypeID = membershipType.MembershipTypeID;
                memberpackageDetail.membershipTypeName = replaceEscapeCharacters(membershipType.ProductName);
                memberpackageDetail.PreviousMembershipType = user.PreviousMembershipType;
                memberpackageDetail.userNo = user.userNo;
                memberpackageDetail.isEdit = true;
                memberpackageDetail.notPartOfPackage = user.notPartOfPackage;

            }
        }

        setState({ ...state, memberpackageDetail: memberpackageDetail })

        setOpen(true);
    }

    //Delete Person
    const DeletePerson = (memberTypeID, member) => {

        if (member.isPrimaryMember) {
            seterrorMsg(TryDeletePrimaryRecordOnMembership);
        }
        else {

            setconfirmOpen({
                dialogBox: true, packageID: memberPackage.MembershipPackageID,
                memTypeID: memberTypeID, useNo: member.userNo,
                deletemsg: ConfirmMsgRemovePersonFromMemberPackage + ' ' + member.firstName + ' ' + member.lastName + '?'
            });
        }
    }


    const ConfirmDeletePerson = () => {
        var deleteConfirmState = { ...confirmopen };
        actionDeleteMembershipTypePerson(dispatch, deleteConfirmState.packageID, deleteConfirmState.memTypeID, deleteConfirmState.useNo);


        if (usersnotpartofpackage && usersnotpartofpackage.length > 0 && usersnotpartofpackage.filter(x => x.userNo == deleteConfirmState.useNo && x.membershipTypeID == 0
            && x.MembershipExpiryDate == '').length > 0) {
            actionUpdateFamilyMemberNotPartOfPackage(dispatch, deleteConfirmState.useNo, false);
        }

        setconfirmOpen({
            dialogBox: false, packageID: 0,
            memTypeID: 0, useNo: 0, deletemsg: ''
        });
    }

    const CancelPersonDelete = () => {

        setconfirmOpen({
            dialogBox: false, packageID: 0,
            memTypeID: 0, useNo: 0, deletemsg: ''
        });
    }

    function validateEmail(email) {
        var re = new RegExp(EmailRegex);
        return re.test(String(email).toLowerCase());
    }

    function validateDOB(dob) {
        var re = new RegExp(DOBRegex);
        let resultRegex = re.test(String(dob).toLowerCase());
        if (resultRegex) {
            let isValidRange = Moment(dob).isBetween(Moment('1899-12-31'), Moment());
            return isValidRange;
        }
        else
            return resultRegex;
    }

    //Enable Confirm Buttom
    const [confirmBtn, setconfirmBtn] = React.useState(true);

    const ValidateMemberPackageQuantities = () => {
        let validRequest = false;

        if (memberPackage && memberPackage.MembershipProducts && memberPackage.MembershipProducts.length > 0) {
            memberPackage.MembershipProducts = memberPackage.MembershipProducts.map(memType => {

                if (memType.MembershipType === "Membership" && ((memType.Users.length < memType.MinQuantity) || (memType.Users.length > memType.MaxQuantity))) {
                    validRequest = true;
                }

                if (memType.MembershipType === "AddOn") {
                    if (((memType.Quantity < memType.MinQuantity) || (memType.Quantity > memType.MaxQuantity))) {
                        validRequest = true;
                    }
                }

                return memType;
            });
        }

        return validRequest;
    }

    const PersonNamesDuplicateCheck = (membership) => {

        let exist = false;
        if (memberPackage && memberPackage.MembershipProducts && membership.isEdit == false) {
            memberPackage.MembershipProducts.filter(x => x.MembershipType === "Membership").map(m => {

                if (m.Users && m.Users.length > 0 && m.Users.filter(x => x.firstName.toLowerCase() == membership.firstName.toLowerCase() && x.lastName.toLowerCase() == membership.lastName.toLowerCase()).length > 0) {
                    exist = true;
                }
            })
        }

        return exist;
    }

    //Save Button MultipleClicks
    const [saveBtn, setsaveBtn] = React.useState(false);

    const saveDialog = () => {

        setsaveBtn(true);

        setTimeout(() => {
            setsaveBtn(false);
        }, 1000)

        if (!ValidateMembershipType()) {
            seterrorMsg('Please fill the required UDFs.');
            return;
        }
        //Add Validation
        var initialerrorstate = { ...errorstate.initialerrorstate };

        if (state.memberpackageDetail.firstName.trim().length < 1) {
            initialerrorstate.first_name.errorstate = true;
            initialerrorstate.first_name.errortext = "First Name is required.";
            seterrorstate({ ...errorstate, initialerrorstate });
        }
        else {
            initialerrorstate.first_name.errorstate = false;
            initialerrorstate.first_name.errortext = "";
            seterrorstate({ ...errorstate, initialerrorstate });
        }

        if (state.memberpackageDetail.lastName.trim().length < 1) {
            initialerrorstate.last_name.errorstate = true;
            initialerrorstate.last_name.errortext = "Last Name is required.";
            seterrorstate({ ...errorstate, initialerrorstate });
        } else {
            initialerrorstate.last_name.errorstate = false;
            initialerrorstate.last_name.errortext = "";
            seterrorstate({ ...errorstate, initialerrorstate });
        }

        if (state.memberpackageDetail.membershipTypeID < 1) {
            initialerrorstate.membershipType.errorstate = true;
            initialerrorstate.membershipType.errortext = "Membership Type is required.";
            seterrorstate({ ...errorstate, initialerrorstate });
        }
        else {
            initialerrorstate.membershipType.errorstate = false;
            initialerrorstate.membershipType.errortext = "";
            seterrorstate({ ...errorstate, initialerrorstate });
        }

        if (state.memberpackageDetail.isPrimaryMember && state.memberpackageDetail.email.trim().length < 1) {
            initialerrorstate.email.errorstate = true;
            initialerrorstate.email.errortext = "Email  is required.";
            seterrorstate({ ...errorstate, initialerrorstate });
        }
        else if (state.memberpackageDetail.email.length > 0 && validateEmail(state.memberpackageDetail.email) == false) {
            initialerrorstate.email.errorstate = true;
            initialerrorstate.email.errortext = "Please enter a valid email address.";
            seterrorstate({ ...errorstate, initialerrorstate });
        }
        else {
            initialerrorstate.email.errorstate = false;
            initialerrorstate.email.errortext = "";
            seterrorstate({ ...errorstate, initialerrorstate });
        }

        if (state.memberpackageDetail.dob) {
            if (state.memberpackageDetail.dob.length > 0
                && state.memberpackageDetail.dob != "DOB"
                && validateDOB(state.memberpackageDetail.dob) == false) {

                initialerrorstate.age.errorstate = true;
                initialerrorstate.age.errortext = "Please enter a valid date of birth.";
                seterrorstate({ ...errorstate, initialerrorstate });
            }
            else {
                initialerrorstate.age.errorstate = false;
                initialerrorstate.age.errortext = "";
                seterrorstate({ ...errorstate, initialerrorstate });
            }
        }


        if (state.memberpackageDetail.isPrimaryMember) {

            if (state.memberpackageDetail.address1.trim().length < 1) {
                initialerrorstate.address1.errorstate = true;
                initialerrorstate.address1.errortext = "Address 1 is required.";
                seterrorstate({ ...errorstate, initialerrorstate });
            } else {
                initialerrorstate.address1.errorstate = false;
                initialerrorstate.address1.errortext = "";
                seterrorstate({ ...errorstate, initialerrorstate });
            }

            if (state.memberpackageDetail.city.trim().length < 1) {
                initialerrorstate.city.errorstate = true;
                initialerrorstate.city.errortext = "City is required.";
                seterrorstate({ ...errorstate, initialerrorstate });
            } else {
                initialerrorstate.city.errorstate = false;
                initialerrorstate.city.errortext = "";
                seterrorstate({ ...errorstate, initialerrorstate });
            }

            if (state.memberpackageDetail.state.trim().length < 1) {
                initialerrorstate.state.errorstate = true;
                initialerrorstate.state.errortext = "State is required.";
                seterrorstate({ ...errorstate, initialerrorstate });
            } else {
                initialerrorstate.state.errorstate = false;
                initialerrorstate.state.errortext = "";
                seterrorstate({ ...errorstate, initialerrorstate });
            }

            if (state.memberpackageDetail.zipcode.trim().length < 1) {
                initialerrorstate.zipcode.errorstate = true;
                initialerrorstate.zipcode.errortext = "Zipcode is required.";
                seterrorstate({ ...errorstate, initialerrorstate });
            } else {
                initialerrorstate.zipcode.errorstate = false;
                initialerrorstate.zipcode.errortext = "";
                seterrorstate({ ...errorstate, initialerrorstate });
            }

            if (state.memberpackageDetail.country.trim().length < 1) {
                initialerrorstate.country.errorstate = true;
                initialerrorstate.country.errortext = "Country is required.";
                seterrorstate({ ...errorstate, initialerrorstate });
            } else {
                initialerrorstate.country.errorstate = false;
                initialerrorstate.country.errortext = "";
                seterrorstate({ ...errorstate, initialerrorstate });
            }
        }

        if (initialerrorstate.first_name.errorstate || initialerrorstate.last_name.errorstate || initialerrorstate.membershipType.errorstate || initialerrorstate.email.errorstate || initialerrorstate.age.errorstate ||
            initialerrorstate.address1.errorstate || initialerrorstate.city.errorstate || initialerrorstate.state.errorstate || initialerrorstate.zipcode.errorstate || initialerrorstate.country.errorstate) {
            setOpen(true);
        }
        else {
            var ageDiff = parseInt(calculateAge(new Date(state.memberpackageDetail.dob)));

            var memType = memberPackage.MembershipProducts.filter(x => x.MembershipTypeID == state.memberpackageDetail.membershipTypeID)[0];

            if (memType.AgeBasedMembership && (ageDiff < memType.MinAge || ageDiff > memType.MaxAge)) {
                initialerrorstate.age.errorstate = true;
                initialerrorstate.age.errortext = "Please enter a valid DOB, Min Age is " + memType.MinAge + " and Max Age is : " + memType.MaxAge;
                seterrorstate({ ...errorstate, initialerrorstate });
            }
            else {
                if (PersonNamesDuplicateCheck(state.memberpackageDetail) == false) {
                    actionUpdateMembershipPackage(dispatch, state.memberpackageDetail, false);

                    if (state.memberpackageDetail.notPartOfPackage) {
                        actionUpdateFamilyMemberNotPartOfPackage(dispatch, state.memberpackageDetail.userNo, true);
                    }

                    setOpen(false);
                }
                else {
                    seterrorMsg('First Name and Last Name is already used.');
                }
            }
        }
    }

    const fieldhandleChange = (event, mem) => {

        var memberpackageDetail = { ...state.memberpackageDetail };

        if (mem) {
            let memTypeID = parseInt(mem.MembershipTypeID);
            memberpackageDetail.membershipTypeID = memTypeID;
            memberpackageDetail.membershipTypeName = mem.ProductName;

            setState({ ...state, memberpackageDetail: memberpackageDetail })
        }

        if (event && event.target.name === "fname") {
            memberpackageDetail.firstName = event.target.value;
            memberpackageDetail.MembershipPackageID = props.membershipPackage.hasOwnProperty("MembershipPackageID") ? props.membershipPackage.MembershipPackageID : 0;
            setState({ ...state, memberpackageDetail: memberpackageDetail });

            if (memberpackageDetail.isPrimaryMember) {
                actionSetFieldValueState(dispatch, "first_name", event.target.value);
            }
        }

        if (event && event.target.name === "lname") {
            memberpackageDetail.lastName = event.target.value;
            setState({ ...state, memberpackageDetail: memberpackageDetail });

            if (memberpackageDetail.isPrimaryMember) {
                actionSetFieldValueState(dispatch, "last_name", event.target.value);
            }
        }

        if (event && event.target.name === "email") {
            memberpackageDetail.email = event.target.value;
            setState({ ...state, memberpackageDetail: memberpackageDetail });

            if (memberpackageDetail.isPrimaryMember) {
                actionSetFieldValueState(dispatch, "email", event.target.value);
            }
        }

        if (event && event.target.name === "dob") {
            memberpackageDetail.dob = Moment(event.target.value).format('YYYY-MM-DD');
            setState({ ...state, memberpackageDetail: memberpackageDetail })
        }

        if (memberpackageDetail.dob === "Invalid date") {
            memberpackageDetail.dob = "";
            setState({ ...state, memberpackageDetail: memberpackageDetail })
        }

        if (event && event.target.name === "phone") {
            memberpackageDetail.phone = event.target.value;
            setState({ ...state, memberpackageDetail: memberpackageDetail });

            if (memberpackageDetail.isPrimaryMember) {
                actionSetFieldValueState(dispatch, "phone_number", event.target.value);
            }
        }

        if (event && event.target.name === "membershipType") {
            let memTypeID = parseInt(event.currentTarget.id);
            memberpackageDetail.membershipTypeID = memTypeID;
            memberpackageDetail.membershipTypeName = event.target.value;

            setState({ ...state, memberpackageDetail: memberpackageDetail })
        }

        if (event && event.target.name === "address1") {
            memberpackageDetail.address1 = event.target.value;
            setState({ ...state, memberpackageDetail: memberpackageDetail });
            actionSetFieldValueState(dispatch, "address1", event.target.value);
        }

        if (event && event.target.name === "address2") {
            memberpackageDetail.address2 = event.target.value;
            setState({ ...state, memberpackageDetail: memberpackageDetail });
            actionSetFieldValueState(dispatch, "address2", event.target.value);
        }

        if (event && event.target.name === "city") {
            memberpackageDetail.city = event.target.value;
            setState({ ...state, memberpackageDetail: memberpackageDetail });
            actionSetFieldValueState(dispatch, "city", event.target.value);
        }

        // if (event && event.target.name === "state") {
        //     memberpackageDetail.state = event.target.value;
        //     setState({ ...state, memberpackageDetail: memberpackageDetail });
        //     actionSetFieldValueState(dispatch, "state", event.target.value);

        // }

        if (event && event.target.name === "zipcode") {
            memberpackageDetail.zipcode = event.target.value;
            setState({ ...state, memberpackageDetail: memberpackageDetail });
            actionSetFieldValueState(dispatch, "zip", event.target.value);
        }

        // if (event && event.target.name === "country") {

        //     memberpackageDetail.country = event.target.value;
        //     setState({ ...state, memberpackageDetail: memberpackageDetail });
        //     actionSetFieldValueState(dispatch, "country", event.target.value);
        // }
    };

    //Dialog Fields End

    //Error Handling Start

    const [errorMsg, seterrorMsg] = React.useState('');

    const errorcancelhandle = () => {
        seterrorMsg('');
    }

    //Error Handling Start


    const changeQuantityHandler = (memberType) => {
        //Check Min and Max Quantity
        //need to add
        memberType.MembershipPackageID = memberPackage.MembershipPackageID;
        actionUpdateMembershipAddonsQuantity(dispatch, memberType);
    }

    const ConfirmMembershipPackage = () => {

        if (orderProducts && orderProducts.length > 0) {
            seterrorMsg(OrderItemsInCartError);
            return;
        }

        if (props.isRenewPackage) {
            let err = ValidateMembersUDFs();
            if (err.length > 0) {
                seterrorMsg(err);
                return;
            }
        }

        if (CountTotalMembers() > memberPackage.MaximumMembersInPackage) {
            seterrorMsg(PackageMaxQtyMsg + memberPackage.MaximumMembersInPackage);
        }
        else if (CountTotalMembers() < memberPackage.MinimumMembersInPackage) {
            seterrorMsg(PackageMinQtyMsg + memberPackage.MinimumMembersInPackage + ' membership(s).');
        }
        else {
            actionShopCartAddMembershipPackage(dispatch, memberPackage, props.isRenewPackage);
            props.constnextredirect();
        }
    }

    const CountTotalMembers = () => {

        let totalMembers = 0;

        if (memberPackage) {
            memberPackage.MembershipProducts.filter(x => x.MembershipType === "Membership").map(m => {

                if (m.Users && m.Users.length > 0) {

                    totalMembers += m.Users.length;
                }
            });
        }

        return totalMembers;
    }

    function calculateAge(birthday) { // birthday is a date
        var ageDifMs = Date.now() - birthday;
        var ageDate = new Date(ageDifMs); // miliseconds from epoch
        return Math.abs(ageDate.getUTCFullYear() - 1970);
    }

    //Click on Cancel Membership Package
    const constredirect = () => {

        if (shopcartMembershipPackage && shopcartMembershipPackage.length < 1) {

            if (props.isRenewPackage) {
                actionResetMemberValidation(dispatch);
                actionResetCustomerUdfs(dispatch);
            }

            if (membershipTypesUdfs.membershipUdfs && membershipTypesUdfs.membershipUdfs.length > 0) {
                actionResetMembershipUDFs(dispatch);
            }

            actionResetFieldValuesState(dispatch);
            actionResetMembershipPackage(dispatch);
        }

        props.history.push({
            pathname: '/memberships'
        })
    }

    const [showMoreInfo, setShowMoreInfo] = React.useState(false);
    const [readmorebtnText, setreadmorebtnText] = React.useState('Read More');

    const ShowMoreInfoClick = () => {

        if (readmorebtnText === 'Read More') {
            setShowMoreInfo(true);
            setreadmorebtnText('Read Less');
        }
        else {
            setShowMoreInfo(false);
            setreadmorebtnText('Read More');
        }
    }


    const GetMembershipPackageDis = (discription) => {

        if (discription) {
            if (showMoreInfo) {
                return discription.substring(0, discription.length - 1);
            }

            return discription.substring(0, DisplayMemPackageDiscriptionCharacters);
        }

        return "";
    }


    const AddReviewMemberToPackage = (user) => {

        var memberpackageDetail = { ...state.memberpackageDetail };

        if (user) {
            memberpackageDetail.popupTitle = 'Add - Person';
            memberpackageDetail.isPrimaryMember = false;
            memberpackageDetail.firstName = user.firstName;
            memberpackageDetail.lastName = user.lastName;
            memberpackageDetail.email = user.email;
            memberpackageDetail.dob = GetUserDOB(user);
            memberpackageDetail.phone = user.phone;
            memberpackageDetail.address1 = user.address1;
            memberpackageDetail.address2 = user.address2;
            memberpackageDetail.city = user.city;
            memberpackageDetail.state = user.state;
            memberpackageDetail.zipcode = user.zipcode;
            memberpackageDetail.isRenewal = user.isRenewal;
            memberpackageDetail.UniquePackageRef = user.UniquePackageRef;
            memberpackageDetail.MembershipExpiryDate = user.MembershipExpiryDate;
            memberpackageDetail.MembershipPackageID = memberPackage.MembershipPackageID;
            memberpackageDetail.membershipTypeID = 0;
            memberpackageDetail.membershipTypeName = '';
            memberpackageDetail.userNo = user.userNo;
            memberpackageDetail.isEdit = false;
            memberpackageDetail.notPartOfPackage = user.notpartofPackage;
        }


        setState({ ...state, memberpackageDetail: memberpackageDetail })

        setOpen(true);

    }

    //Membership Popup
    const BackMembershipPopup = () => {
        actionResetMemberValidation(dispatch);
        actionResetFieldValuesState(dispatch);
        setisredirectclicked(true);
    }

    useEffect(() => {

        if (isredirectclicked) {
            setisredirectclicked(false);
            let memPackID = 0;

            if (memberPackage && memberPackage.hasOwnProperty('MembershipPackageID')) {
                memPackID = memberPackage.MembershipPackageID;
            }

            props.history.push({
                pathname: '/memberships/membervalidate/' + memPackID
            })
        }

    }, [isredirectclicked]);

    const RenewMembershp = (mp) => {

        //Update Primar Record

        if (customer.customer.length > 0) {
            actionSetFieldValueState(dispatch, "first_name", customer.customer[0].FirstName);
            actionSetFieldValueState(dispatch, "last_name", customer.customer[0].LastName);
            actionSetFieldValueState(dispatch, "email", customer.customer[0].GuestEmail);
            actionSetFieldValueState(dispatch, "phone_number", customer.customer[0].CustomerAddress[0].MobilePhone);
            actionSetFieldValueState(dispatch, "address1", customer.customer[0].CustomerAddress[0].Street1);
            actionSetFieldValueState(dispatch, "address2", customer.customer[0].CustomerAddress[0].Street2);
            actionSetFieldValueState(dispatch, "city", customer.customer[0].CustomerAddress[0].CitySuburb);
            actionSetFieldValueState(dispatch, "state", customer.customer[0].CustomerAddress[0].State);
            actionSetFieldValueState(dispatch, "zip", customer.customer[0].CustomerAddress[0].Postcode);
            actionSetFieldValueState(dispatch, "country", customer.customer[0].CustomerAddress[0].Country);
        }

        actionUpdatePackageForRenew(dispatch, mp.MembershipPackageID, memmemberhisps, customer.customer);
        setopenMembership(false);

        props.history.push({
            pathname: '/memberships/renew/' + mp.MembershipPackageID
        })
    }

    const renewmembershipsdistinct = () => {
        const renewmemshipscollection = [];

        membermemberhisps.membermerberhips[0].Memberships.filter(x => x.IsRenewed == false).map(x => {

            if (renewmemshipscollection.filter(y => y.MembershipPackageID == x.MembershipPackageID).length == 0) {
                renewmemshipscollection.push(x);
            }
        });

        return renewmemshipscollection;
    }
    const classes = useStyles();

    //Show Fields

    let displayclass = "";
    if (state.memberpackageDetail.isPrimaryMember)
        displayclass = classes.visible;
    else
        displayclass = classes.displaynone;


    const replaceEscapeCharacters = (item) => {
        var itemValue = item.split("\\r\\n").join("<br />");
        itemValue = itemValue.split("\\").join("");
        return itemValue;
    }

    const GetMembershipTypeQty = (memPackage, memTypeProd) => {

        let availQty = '';

        if (memTypeProd) {

            if (memTypeProd.MinQuantity > 0) {
                availQty = '(Min Qty : ' + memTypeProd.MinQuantity + ', Max Qty : ' + memTypeProd.MaxQuantity + ')';
            }

            if (memTypeProd.MinQuantity < 1 || memTypeProd.MinQuantity == memTypeProd.MaxQuantity) {
                availQty = '(Max Qty : ' + memTypeProd.MaxQuantity + ')';
            }

            if (memTypeProd.MaxQuantity >= memPackage.MaximumMembersInPackage && memTypeProd.MinQuantity > 0) {
                availQty = '(Min Qty : ' + memTypeProd.MinQuantity + ')';
            }

            if (memTypeProd.MaxQuantity >= memPackage.MaximumMembersInPackage && memTypeProd.MinQuantity < 1) {
                availQty = '';
            }

            if (memTypeProd.MinQuantity == memPackage.MaximumMembersInPackage) {
                availQty = '';
            }
        }

        return availQty;
    }

    const GetDefaultMembershipName = (membershipTypeName) => {

        let memtypename = '';

        if (props.membershipPackage && props.membershipPackage.MembershipProducts)
            if (props.membershipPackage.MembershipProducts.filter(x => x.MembershipType === "Membership").length == 1) {
                memtypename = props.membershipPackage.MembershipProducts.filter(x => x.MembershipType === "Membership")[0].ProductName;
            }
            else {
                memtypename = membershipTypeName;
            }

        return memtypename;
    }

    const ValidateMembershipType = () => {
        let valid = true;
        var memberpackageDetail = { ...state.memberpackageDetail };

        if (membershipTypesUdfs.membershipUdfs && membershipTypesUdfs.membershipUdfs.length > 0) {

            membershipTypesUdfs.membershipUdfs.filter(x => x.MembershipTypeID == memberpackageDetail.membershipTypeID).filter(x => x.UDFCategories).map(udfCategorey => {

                if (udfCategorey.UDFCategories && udfCategorey.UDFCategories.length > 0 && valid) {

                    udfCategorey.UDFCategories.map(udfCate => {
                        udfCate.UserDefinedFields.map((udf) => {

                            if (valid) {
                                if (udf.IsRequired && udf.Users.length == 0) {
                                    valid = false;
                                }
                                else if (udf.IsRequired && udf.Users.length > 0 && udf.Users.filter(x => x.userID == memberpackageDetail.userNo).length < 1) {
                                    valid = false;
                                }
                                else if (udf.IsRequired && udf.Users.length > 0 && udf.Users.filter(x => x.userID == memberpackageDetail.userNo).length > 0) {
                                    let user = udf.Users.filter(x => x.userID == memberpackageDetail.userNo)[0];

                                    if (user.userUDFValue !== undefined && user.userUDFValue !== null) {

                                        if ((udf.UDFType === "Text" || udf.UDFType === "Decimal") && user.userUDFValue.length < 1) {
                                            valid = false;
                                        }
                                        else if (udf.UDFType === "Bit" && user.userUDFValue === false) {
                                            valid = false;
                                        }
                                    }
                                }
                            }
                        })
                    });
                }
            });
        }

        return valid;
    }
    const ValidateMembersUDFs = () => {

        let error = '';

        if (membershipTypesUdfs.membershipUdfs && membershipTypesUdfs.membershipUdfs.length > 0) {

            membershipTypesUdfs.membershipUdfs.filter(x => x.UDFCategories).map(membershipType => {

                let memberusers = GetMembershipTypeUserCount(membershipType.MembershipTypeID);

                if (membershipType.UDFCategories != null && membershipType.UDFCategories.length > 0 && error.length == 0 && memberusers > 0) {

                    membershipType.UDFCategories.map((udfCategorey, i) => {

                        udfCategorey.UserDefinedFields.map((udf) => {
                            if (error.length == 0 && udf.IsRequired && udf.hasOwnProperty('Users') && udf.Users !== undefined && memberusers != udf.Users.length) {
                                error = 'Please fill the required UDFs for Membership Type ' + GetMembershipTypeName(membershipType.MembershipTypeID);
                                return;
                            }
                        })
                    });
                }
            })
        }

        return error;
    }

    const GetMembershipTypeName = (memTypeID) => {
        let memberTypeName = '';

        if (memberPackage) {
            memberTypeName = memberPackage.MembershipProducts.filter(x => x.MembershipType === "Membership" && x.MembershipTypeID == memTypeID)[0].ProductName;
        }

        return memberTypeName;
    }

    const GetMembershipTypeUserCount = (memTypeID) => {
        let totalMembers = 0;

        if (memberPackage) {
            memberPackage.MembershipProducts.filter(x => x.MembershipType === "Membership" && x.MembershipTypeID == memTypeID).map(m => {

                if (m.Users && m.Users.length > 0) {

                    totalMembers += m.Users.length;
                }
            });
        }

        return totalMembers;
    }

    return (
        <div className={classes.root} style={{ width: "80%", margin: "0 auto" }}>
            <ErrorHandling msg={errorMsg.length > 0 ? errorMsg : ''}
                open={errorMsg.length > 0 ? true : false} handleclose={errorcancelhandle} />
            <Grid container spacing={3}>

                <Hidden xsDown mdUp>
                    <Grid item lg={3} sm={12} xs={12} align="center" >

                        <Grid align="center" item xs={12} ms={12} lg={12} style={{ minHeight: "200px" }}>

                            <Typography className={classes.tourheaderbox} align="center" variant="h2" style={{ marginTop: "20px", padding: "4px" }}>
                                {PackageDiscriptionHeading}
                            </Typography>

                            <Grid item xs={12} style={{ border: "0.5px solid silver" }}>
                                <Typography variant="subtitle2" color="textSecondary" style={{ padding: "20px" }} align="justify">
                                    {ReactHtmlParser(GetMembershipPackageDis(props.membershipPackage.Description))}
                                </Typography>

                                <Link
                                    component="button"
                                    variant="body2"
                                    onClick={ShowMoreInfoClick}
                                    style={{ display: props.membershipPackage.Description && props.membershipPackage.Description.length < DisplayMemPackageDiscriptionCharacters ? 'none' : 'block' }}
                                >
                                    {readmorebtnText}
                                </Link>
                            </Grid>
                        </Grid>

                    </Grid>
                </Hidden>

                <Hidden smUp>
                    <Grid item lg={3} sm={12} xs={12} align="center" >

                        <Grid align="center" item xs={12} ms={12} lg={12} style={{ minHeight: "200px" }}>

                            <Typography className={classes.smalltourheaderbox} align="center" variant="h3" style={{ marginTop: "20px", padding: "4px" }}>
                                {PackageDiscriptionHeading}
                            </Typography>

                            <Grid item xs={12} style={{ border: "0.5px solid silver" }}>
                                <Typography variant="subtitle2" color="textSecondary" style={{ padding: "20px" }} align="justify">
                                    {ReactHtmlParser(GetMembershipPackageDis(props.membershipPackage.Description))}
                                </Typography>

                                <Link
                                    component="button"
                                    variant="body2"
                                    onClick={ShowMoreInfoClick}
                                    style={{ display: props.membershipPackage.Description && props.membershipPackage.Description.length < DisplayMemPackageDiscriptionCharacters ? 'none' : 'block' }}
                                >
                                    {readmorebtnText}
                                </Link>
                            </Grid>
                        </Grid>

                    </Grid>
                </Hidden>

                <Grid item xs={12}>
                    <Button variant="contained" className={classes.primarycolor} size="large" startIcon={<PersonAddIcon />}
                        onClick={handleClickOpen}>
                        Add Person
                    </Button>
                </Grid>



                <Grid container item lg={8} sm={12} xs={12} justifyContent="flex-end">

                    <Grid item lg={12} sm={12} xs={12} style={{ marginBottom: "20px" }}>

                        <Hidden smDown>
                            <Typography className={classes.tourheaderbox} align="center" variant="h2" style={{ marginTop: "20px", padding: "4px" }}>
                                Membership Types
                            </Typography>
                        </Hidden>

                        <Hidden xsDown mdUp>
                            <Typography className={classes.smalltourheaderbox} align="center" variant="h3" style={{ marginTop: "20px", padding: "4px" }}>
                                Membership Types
                            </Typography>
                        </Hidden>

                        <Hidden smUp>
                            <Typography className={classes.smalltourheaderbox} align="center" variant="h3" style={{ marginTop: "20px", padding: "4px" }}>
                                Membership Types
                            </Typography>
                        </Hidden>
                    </Grid>

                    {props.membershipPackage.hasOwnProperty("MembershipProducts") && props.membershipPackage.MembershipProducts.map((membershipProduct, i) => {

                        return membershipProduct.MembershipType === "Membership" ?

                            <Grid container style={{ marginTop: '10px' }} key={i}>
                                <Grid lg={8} sm={8} xs={8} style={{ marginTop: '5px' }}>

                                    <Hidden smDown>
                                        <Typography variant="h3">{replaceEscapeCharacters(membershipProduct.ProductName)} </Typography>
                                        <Typography className={membershipProduct.hasOwnProperty('Users') && membershipProduct.Users.length < membershipProduct.MinQuantity || membershipProduct.Users.length > membershipProduct.MaxQuantity ? classes.errorColor : classes.defaultColor} style={{ marginTop: "3px", marginLeft: "5px" }}> {membershipProduct.AgeBasedMembership ? '(Min Age : ' + membershipProduct.MinAge + ', Max Age : ' + membershipProduct.MaxAge + ')' : ''} {GetMembershipTypeQty(props.membershipPackage, membershipProduct)}
                                        </Typography>
                                    </Hidden>

                                    <Hidden xsDown mdUp>
                                        <Typography variant="h4">{replaceEscapeCharacters(membershipProduct.ProductName)}</Typography>
                                        <Typography className={membershipProduct.hasOwnProperty('Users') && membershipProduct.Users.length < membershipProduct.MinQuantity || membershipProduct.Users.length > membershipProduct.MaxQuantity ? classes.errorColor : classes.defaultColor} variant="h6" style={{ marginTop: "3px", marginLeft: "5px" }}> {membershipProduct.AgeBasedMembership ? '(Min Age : ' + membershipProduct.MinAge + ', Max Age : ' + membershipProduct.MaxAge + ')' : ''} {GetMembershipTypeQty(props.membershipPackage, membershipProduct)}
                                        </Typography>
                                    </Hidden>

                                    <Hidden smUp>
                                        <Typography variant="h5">{replaceEscapeCharacters(membershipProduct.ProductName)}</Typography>
                                        <Typography className={membershipProduct.hasOwnProperty('Users') && membershipProduct.Users.length < membershipProduct.MinQuantity || membershipProduct.Users.length > membershipProduct.MaxQuantity ? classes.errorColor : classes.defaultColor} variant="h6" style={{ marginTop: "3px", marginLeft: "5px" }}> {membershipProduct.AgeBasedMembership ? '(Min Age : ' + membershipProduct.MinAge + ', Max Age : ' + membershipProduct.MaxAge + ')' : ''} {GetMembershipTypeQty(props.membershipPackage, membershipProduct)}
                                        </Typography>
                                    </Hidden>


                                </Grid>
                                <Grid item lg={4} sm={4} xs={4} align="right">

                                    <Hidden smDown>
                                        <Typography variant="h4"> {genfunction.ccyFormat(membershipProduct.Price)}</Typography>
                                    </Hidden>

                                    <Hidden xsDown mdUp>
                                        <Typography variant="h5"> {genfunction.ccyFormat(membershipProduct.Price)}</Typography>
                                    </Hidden>

                                    <Hidden smUp>
                                        <Typography variant="h6"> {genfunction.ccyFormat(membershipProduct.Price)}</Typography>
                                    </Hidden>
                                </Grid>
                                <Grid xs={12} className={classes.hr} style={{ marginTop: '5px' }}>
                                </Grid>

                                <Grid item lg={12} sm={12} xs={12} style={{ minHeight: '100px' }}>
                                    {membershipProduct.Users && membershipProduct.Users.length > 0
                                        ? membershipProduct.Users.map((membership, i) => {
                                            return (
                                                <div key={i}>
                                                    <Grid item lg={12} sm={12} xs={12} container spacing={2} style={{ marginTop: "10px" }}>
                                                        <CancelIcon
                                                            className={classes.AddHoverOnIcons}
                                                            onClick={() => { DeletePerson(membershipProduct.MembershipTypeID, membership) }}
                                                            color={"error"}
                                                        />
                                                        <EditIcon
                                                            className={classes.AddHoverOnIcons}
                                                            color={"primary"}
                                                            onClick={() => { EditPerson(membership, membershipProduct.MembershipTypeID) }}
                                                        />

                                                        <Hidden smDown>
                                                            <Typography style={{ fontSize: "16px", marginLeft: "15px" }}>
                                                                {membership.firstName}  {membership.lastName}
                                                            </Typography>
                                                        </Hidden>

                                                        <Hidden xsDown mdUp>
                                                            <Typography style={{ fontSize: "14px", marginLeft: "15px" }}>
                                                                {membership.firstName}  {membership.lastName}
                                                            </Typography>
                                                        </Hidden>

                                                        <Hidden smUp>
                                                            <Typography style={{ fontSize: "12px", marginLeft: "15px" }}>
                                                                {membership.firstName}  {membership.lastName}
                                                            </Typography>
                                                        </Hidden>
                                                    </Grid>

                                                    <Grid item lg={12} sm={12} xs={12} container spacing={2} style={{ marginTop: "10px" }}>

                                                        {membershipProduct.hasOwnProperty('Users') && membershipProduct.Users.length < membershipProduct.MinQuantity ?
                                                            <>
                                                                <Hidden smDown>
                                                                    <Typography className={classes.errorColor} style={{ fontSize: "16px", marginLeft: "50px", marginTop: "10px" }}>{ValidateMembershipMinQuantity}</Typography>
                                                                </Hidden>

                                                                <Hidden xsDown mdUp>
                                                                    <Typography className={classes.errorColor} style={{ fontSize: "14px", marginTop: "10px" }}>{ValidateMembershipMinQuantity}</Typography>
                                                                </Hidden>

                                                                <Hidden smUp>
                                                                    <Typography className={classes.errorColor} style={{ fontSize: "12px", marginTop: "10px" }}>{ValidateMembershipMinQuantity}</Typography>
                                                                </Hidden>

                                                            </> : ''
                                                        }
                                                    </Grid>
                                                </div>
                                            )
                                        })

                                        :
                                        <Grid item lg={12} sm={12} xs={12} container spacing={2} style={{ marginTop: "10px" }}>

                                            {membershipProduct.hasOwnProperty('Users') && membershipProduct.Users.length < membershipProduct.MinQuantity ?
                                                <>
                                                    <Hidden smDown>
                                                        <Typography className={classes.errorColor} style={{ fontSize: "16px", marginLeft: "50px", marginTop: "10px" }}>{ValidateMembershipMinQuantity}</Typography>
                                                    </Hidden>

                                                    <Hidden xsDown mdUp>
                                                        <Typography className={classes.errorColor} style={{ fontSize: "14px", marginTop: "10px" }}>{ValidateMembershipMinQuantity}</Typography>

                                                    </Hidden>

                                                    <Hidden smUp>
                                                        <Typography className={classes.errorColor} style={{ fontSize: "12px", marginTop: "10px" }}>{ValidateMembershipMinQuantity}</Typography>
                                                    </Hidden>

                                                </> : ''
                                            }



                                            {membershipProduct.hasOwnProperty('Users') && membershipProduct.Users.length <= membershipProduct.MaxQuantity && membershipProduct.Users.length >= membershipProduct.MinQuantity ?
                                                <>
                                                    <Hidden smDown>
                                                        <Typography style={{ fontSize: "16px", marginLeft: "50px", marginTop: "10px" }}>No person is currently assigned to this type.</Typography>
                                                    </Hidden>

                                                    <Hidden xsDown mdUp>
                                                        <Typography style={{ fontSize: "14px", marginTop: "10px" }}>No person is currently assigned to this type.</Typography>

                                                    </Hidden>

                                                    <Hidden smUp>
                                                        <Typography style={{ fontSize: "12px", marginTop: "10px" }}>No person is currently assigned to this type.</Typography>

                                                    </Hidden>
                                                </> : ''
                                            }
                                        </Grid>


                                    }

                                    {membershipProduct.hasOwnProperty('Users') && membershipProduct.Users.length > membershipProduct.MaxQuantity ?
                                        <Grid item lg={12} sm={12} xs={12} container spacing={2} style={{ marginTop: "10px" }}>

                                            <Hidden smDown>
                                                <Typography className={classes.errorColor} style={{ fontSize: "16px", marginLeft: "50px", marginTop: "10px" }}>{ValidateMembershipMaxQuantity}</Typography>

                                            </Hidden>

                                            <Hidden xsDown mdUp>
                                                <Typography className={classes.errorColor} style={{ fontSize: "14px", marginTop: "10px" }}>{ValidateMembershipMaxQuantity}</Typography>
                                            </Hidden>

                                            <Hidden smUp>
                                                <Typography className={classes.errorColor} style={{ fontSize: "12px", marginTop: "10px" }}>{ValidateMembershipMaxQuantity}</Typography>
                                            </Hidden>
                                        </Grid>
                                        :
                                        ''
                                    }

                                </Grid>
                            </Grid>

                            : null
                    })}

                    {props.isRenewPackage ?
                        <Grid align="center" item xs={12} ms={12} lg={12} style={{ minHeight: "100px" }}>

                            <Typography className={classes.tourheaderbox} align="center" variant="h2" style={{ marginTop: "20px", padding: "4px" }}>
                                Individuals not included in Renewal
                            </Typography>
                            <Grid item xs={12}>
                                <Typography variant="subtitle2" color="textSecondary" style={{ padding: "20px" }} align="justify">
                                    Some or all of the members are not available in this package. If you wish to review these members then add them to the appropriate membership type.
                                </Typography>


                                {usersnotpartofpackage && usersnotpartofpackage.length > 0 && usersnotpartofpackage.filter(x => x.notpartofPackage == true).length > 0 ?
                                    <Table size="small" className={classes.table} aria-label="spanning table" style={{ padding: "20px" }}>
                                        <TableBody>
                                            {usersnotpartofpackage.filter(x => x.notpartofPackage == true).map(u => (
                                                <TableRow>
                                                    <TableCell className={classes.tablecell} align="center">{u.firstName} {u.lastName}</TableCell>
                                                    <TableCell className={classes.tablecell + " " + classes.AddHoverOnIcons} align="center">
                                                        <Button variant="contained" className={classes.primarycolor} size="small" startIcon={<PersonAddIcon />}
                                                            onClick={() => AddReviewMemberToPackage(u)}>
                                                            Add to Package
                                                        </Button>
                                                    </TableCell>

                                                </TableRow>

                                            ))}
                                        </TableBody>
                                    </Table>
                                    :
                                    <Typography variant="subtitle2" color="textSecondary" style={{ padding: "20px" }} align="center">
                                        No member record found.
                                    </Typography>
                                }

                            </Grid>
                        </Grid> : null}


                    {props.membershipPackage.hasOwnProperty("MembershipProducts") &&
                        props.membershipPackage.MembershipProducts.filter(x => x.MembershipType === "AddOn").length > 0 ?
                        <>
                            <Grid item lg={12} sm={12} xs={12}>

                                <Hidden smDown>
                                    <Typography className={classes.tourheaderbox} align="center" variant="h2" style={{ marginTop: "20px", padding: "4px" }}>
                                        Add Ons
                                    </Typography>
                                </Hidden>

                                <Hidden xsDown mdUp>
                                    <Typography className={classes.smalltourheaderbox} align="center" variant="h3" style={{ marginTop: "20px", padding: "4px" }}>
                                        Add Ons
                                    </Typography>
                                </Hidden>

                                <Hidden smUp>
                                    <Typography className={classes.smalltourheaderbox} align="center" variant="h4" style={{ marginTop: "20px", padding: "4px" }}>
                                        Add Ons
                                    </Typography>
                                </Hidden>

                            </Grid>
                            <Grid container item lg={12} sm={12} xs={12} className={classes.hr}>
                            </Grid></>
                        : null}

                    {props.membershipPackage.hasOwnProperty("MembershipProducts") && props.membershipPackage.MembershipProducts.map((addonMembership, i) => {

                        return addonMembership.MembershipType === "AddOn" ?
                            <Grid container lg={12} sm={12} xs={12} style={{ marginTop: "10px" }} key={i}>
                                <Grid container item lg={6} sm={6} xs={6} >

                                    <Hidden smDown>
                                        <Typography variant="h3" style={{ marginTop: "10px" }}>{replaceEscapeCharacters(addonMembership.ProductName)} </Typography>
                                    </Hidden>

                                    <Hidden xsDown mdUp>
                                        <Typography variant="h4" style={{ marginTop: "10px" }}>{replaceEscapeCharacters(addonMembership.ProductName)} </Typography>
                                    </Hidden>

                                    <Hidden smUp>
                                        <Typography variant="h5" style={{ marginTop: "10px" }}>{replaceEscapeCharacters(addonMembership.ProductName)} </Typography>
                                    </Hidden>

                                </Grid>
                                <Grid item lg={3} sm={3} xs={3} align="left" >
                                    {(addonMembership.Quantity > 0 || addonMembership.MinQuantity > 0) ? () => changeQuantityHandler(addonMembership) : ''}
                                    <Checkbox
                                        color="primary"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                        onChange={() => changeQuantityHandler(addonMembership)}
                                        checked={(addonMembership.Quantity > 0 || addonMembership.MinQuantity > 0)}
                                    />
                                </Grid>

                                <Grid item lg={3} sm={3} xs={3} align="right" style={{ marginTop: "10px" }}>
                                    <Hidden smDown>
                                        <Typography variant="h4"> {genfunction.ccyFormat(addonMembership.Price)}</Typography>
                                    </Hidden>

                                    <Hidden xsDown mdUp>
                                        <Typography variant="h5"> {genfunction.ccyFormat(addonMembership.Price)}</Typography>
                                    </Hidden>

                                    <Hidden smUp>
                                        <Typography variant="h6"> {genfunction.ccyFormat(addonMembership.Price)}</Typography>
                                    </Hidden>
                                </Grid>
                            </Grid>

                            : null
                    })}

                    <Grid container xs={12}>
                        <Grid item lg={12} sm={12} xs={12} align="right">
                            <Grid style={{ padding: "30px 0px 30px 0px" }}>

                                <Hidden smDown>
                                    <Typography variant="h4">Tax = {genfunction.ccyFormat(genfunction.CalculateMembershipPackageTotal(memberPackage).TaxTotal)}</Typography>
                                    <Typography variant="h4">Total = {genfunction.ccyFormat(genfunction.CalculateMembershipPackageTotal(memberPackage).TotalAmount)}</Typography>
                                </Hidden>

                                <Hidden xsDown mdUp>
                                    <Typography variant="h5">Tax = {genfunction.ccyFormat(genfunction.CalculateMembershipPackageTotal(memberPackage).TaxTotal)}</Typography>
                                    <Typography variant="h5">Total = {genfunction.ccyFormat(genfunction.CalculateMembershipPackageTotal(memberPackage).TotalAmount)}</Typography>
                                </Hidden>

                                <Hidden smUp>
                                    <Typography variant="h6">Tax = {genfunction.ccyFormat(genfunction.CalculateMembershipPackageTotal(memberPackage).TaxTotal)}</Typography>
                                    <Typography variant="h">Total = {genfunction.ccyFormat(genfunction.CalculateMembershipPackageTotal(memberPackage).TotalAmount)}</Typography>
                                </Hidden>

                            </Grid>

                            <Grid item style={{ padding: "30px 0px 30px 0px" }}>

                                <Hidden smDown>
                                    <Button variant="contained" onClick={() => constredirect()} size="large" className={classes.primarycolor}
                                        style={{ marginRight: "10px", marginTop: 0 }}>
                                        Cancel
                                    </Button>
                                    <Button variant="contained"
                                        onClick={() => ConfirmMembershipPackage()} disabled={ValidateMemberPackageQuantities()}
                                        className={classes.primarycolor}
                                        style={{ marginTop: 0 }}
                                        size="large" >
                                        Add to Cart
                                    </Button>
                                </Hidden>

                                <Hidden xsDown mdUp>
                                    <Button variant="contained" onClick={() => constredirect()} size="large" className={classes.primarycolor}
                                        style={{ marginRight: "10px", marginTop: 10 }}>
                                        Cancel
                                    </Button>
                                    <Button variant="contained"
                                        onClick={() => ConfirmMembershipPackage()} disabled={ValidateMemberPackageQuantities()}
                                        className={classes.primarycolor}
                                        style={{ marginTop: 10 }}
                                        size="large" >
                                        Add to Cart
                                    </Button>
                                </Hidden>

                                <Hidden smUp>
                                    <Button variant="contained" onClick={() => constredirect()} size="medium" className={classes.primarycolor}
                                        style={{ marginRight: "10px", marginTop: 10 }}>
                                        Cancel
                                    </Button>
                                    <Button variant="contained"
                                        onClick={() => ConfirmMembershipPackage()} disabled={ValidateMemberPackageQuantities()}
                                        className={classes.primarycolor}
                                        style={{ marginTop: 10 }}
                                        size="medium" >
                                        Add to Cart
                                    </Button>
                                </Hidden>

                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item lg={1} xs={12} align="center">
                    <Divider orientation="vertical" flexItem style={{ border: "0.5px solid silver", marginTop: "20px", marginBottom: "-30px" }} />
                </Grid>

                <Hidden smDown>
                    <Grid item lg={3} sm={12} xs={12} align="center"  >

                        <Grid align="center" item xs={12} sm={12} lg={12} style={{ minHeight: "300px" }}>

                            <Typography className={classes.tourheaderbox} align="center" variant="h2" style={{ marginTop: "20px", padding: "4px" }}>
                                {PackageDiscriptionHeading}
                            </Typography>
                            <Grid item xs={12} style={{ border: "0.5px solid silver" }}>
                                <Typography variant="subtitle2" color="textSecondary" style={{ padding: "20px" }} align="justify">
                                    {ReactHtmlParser(GetMembershipPackageDis(props.membershipPackage.Description))}
                                </Typography>

                                <Link
                                    component="button"
                                    variant="body2"
                                    onClick={ShowMoreInfoClick}
                                    style={{ display: props.membershipPackage.Description && props.membershipPackage.Description.length < DisplayMemPackageDiscriptionCharacters ? 'none' : 'block' }}
                                >
                                    {readmorebtnText}
                                </Link>
                            </Grid>
                        </Grid>
                    </Grid>
                </Hidden>

                {/* Show Memberships Start */}

                <Dialog open={openMembership} onClose={handleCloseMembership}
                    aria-labelledby="form-dialog-title">

                    <DialogTitle id="form-dialog-title" className={classes.dialogTitleHeader} >
                        <Typography className="AddPersonMembershipTitle">
                            Current Memberships
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers={true}>
                        {membermemberhisps && membermemberhisps.membermerberhips && membermemberhisps.membermerberhips[0] !== undefined && membermemberhisps.membermerberhips[0].Memberships !== undefined && membermemberhisps.membermerberhips[0].Memberships.length > 0 && membermemberhisps.membermerberhips[0].Memberships.filter(x => x.IsCancelled == false && x.IsRenewed == false).length > 0 ?
                            <Table size="small" className={classes.table} aria-label="spanning table" style={{ padding: "20px" }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Package Name</TableCell>
                                        <TableCell align="right">Expiry Date</TableCell>
                                        <TableCell align="right">Action</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {renewmembershipsdistinct().map(x => (

                                        <TableRow>
                                            <TableCell className={classes.tablecell} align="center">{x.MembershipPackageName}</TableCell>
                                            <TableCell className={classes.tablecell} align="center">{Moment(x.MembershipExpiryDate).format('YYYY-MM-DD')}</TableCell>

                                            <TableCell className={classes.tablecell + " " + classes.AddHoverOnIcons} align="center">
                                                <Button className={classes.primarycolor} variant="contained" size="medium" onClick={() => RenewMembershp(x)}>
                                                    Renew
                                                </Button>
                                            </TableCell>

                                        </TableRow>

                                    ))}
                                    <TableRow>
                                        <TableCell className={classes.tablecell}></TableCell>
                                        <TableCell className={classes.tablecell}></TableCell>
                                        <TableCell className={classes.tablecell}></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className={classes.tablecell}></TableCell>
                                        <TableCell className={classes.tablecell}></TableCell>

                                        <TableCell className={classes.tablecell} align="right">
                                            <Button className={classes.primarycolor} variant="contained" size="medium" onClick={BackMembershipPopup}>
                                                Back
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>

                            </Table>
                            : null
                        }
                    </DialogContent>
                </Dialog>

                {/* Show Memberships End */}

            </Grid>



            {/* Add/Edit Person Dialog Start */}

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
            >

                <DialogTitle id="form-dialog-title" className={classes.dialogTitleHeader} >
                    <Typography className="AddPersonMembershipTitle">
                        {state.memberpackageDetail.popupTitle}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers={true}>


                    <form className={classes.root + " addmembership webkitScroll"}
                        noValidate autoComplete="off"
                    >
                        <Grid container xs={12} spacing={1}>

                            {props.isRenewPackage && state.memberpackageDetail.isEdit ?
                                <><Grid item xs={6} >
                                    <Typography variant="subtitle1" color="textSecondary">Current Membership Type : </Typography>
                                </Grid>
                                    <Grid item xs={6} >
                                        <Typography variant="subtitle1" color="textSecondary"> {state.memberpackageDetail.PreviousMembershipType}</Typography>
                                    </Grid>

                                    <Grid item xs={6} >
                                        <Typography variant="subtitle1" color="textSecondary">Expiry Date :  </Typography>
                                    </Grid>
                                    <Grid item xs={6} >
                                        <Typography variant="subtitle1" color="textSecondary"> {Moment(state.memberpackageDetail.MembershipExpiryDate).format('YYYY-MM-DD')}</Typography>
                                    </Grid>
                                </>

                                : null}

                            <Grid item xs={6}>
                                <Typography variant="subtitle1" color="textSecondary">Membership Type</Typography>
                            </Grid>
                            <Grid item xs={6} >
                                <FormControl style={{ width: "100%" }} error={errorstate.initialerrorstate.membershipType.errorstate}>
                                    <Select
                                        labelId="Membership Type"
                                        id="membershipType"
                                        name="membershipType"
                                        displayEmpty
                                        value={GetDefaultMembershipName(state.memberpackageDetail.membershipTypeName)}
                                        onChange={fieldhandleChange}
                                        fullWidth={true}
                                    >

                                        {props.membershipPackage.hasOwnProperty("MembershipProducts") &&
                                            props.membershipPackage.MembershipProducts.filter(x => x.MembershipType === "Membership").map((membershipProduct, i) =>
                                            (
                                                state.memberpackageDetail.isEdit === false ?
                                                    membershipProduct.Users.length < membershipProduct.MaxQuantity ?
                                                        <MenuItem
                                                            key={i}
                                                            id={membershipProduct.MembershipTypeID}
                                                            value={replaceEscapeCharacters(membershipProduct.ProductName)}>
                                                            {replaceEscapeCharacters(membershipProduct.ProductName)}
                                                        </MenuItem>
                                                        : null
                                                    :
                                                    <MenuItem
                                                        key={i}
                                                        id={membershipProduct.MembershipTypeID}
                                                        value={replaceEscapeCharacters(membershipProduct.ProductName)}>
                                                        {replaceEscapeCharacters(membershipProduct.ProductName)}
                                                    </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={6}>
                                <TextField
                                    margin="dense"
                                    autoFocus
                                    onChange={fieldhandleChange}
                                    name="fname"
                                    id="fname"
                                    label="First Name"
                                    fullWidth={true}
                                    error={errorstate.initialerrorstate.first_name.errorstate}
                                    helperText={errorstate.initialerrorstate.first_name.errortext}
                                    value={state.memberpackageDetail.firstName}
                                    disabled={props.isRenewPackage && state.memberpackageDetail.isEdit}
                                    inputProps={{ maxLength: AddPersonFirstNameLength }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    margin="dense"
                                    onChange={fieldhandleChange}
                                    id="lname"
                                    name="lname"
                                    label="Last Name"
                                    error={errorstate.initialerrorstate.last_name.errorstate}
                                    helperText={errorstate.initialerrorstate.last_name.errortext}
                                    value={state.memberpackageDetail.lastName}
                                    fullWidth={true}
                                    disabled={props.isRenewPackage && state.memberpackageDetail.isEdit}
                                    inputProps={{ maxLength: AddPersonLastNameLength }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    margin="dense"
                                    onChange={fieldhandleChange}
                                    id="email"
                                    name="email"
                                    label={state.memberpackageDetail.isPrimaryMember ? 'Email' : 'Email (Optional)'}
                                    type="email"
                                    fullWidth={true}
                                    value={state.memberpackageDetail.email}
                                    error={errorstate.initialerrorstate.email.errorstate}
                                    helperText={errorstate.initialerrorstate.email.errortext}
                                    inputProps={{ maxLength: AddPersonEmailLength }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    margin="dense"
                                    type="date"
                                    name="dob"
                                    id="dob"
                                    InputLabelProps={{ shrink: true }}
                                    label="DOB (Optional)"
                                    value={state.memberpackageDetail.dob}
                                    onChange={fieldhandleChange}
                                    error={errorstate.initialerrorstate.age.errorstate}
                                    helperText={errorstate.initialerrorstate.age.errortext}
                                    fullWidth={true}
                                    inputProps={{ maxLength: AddPersonDOBLength }}
                                />
                            </Grid>
                            <Grid item xs={12} >
                                <TextField
                                    margin="dense"
                                    id="phone"
                                    name="phone"
                                    label="Phone # (Optional)"
                                    type="text"
                                    fullWidth={true}
                                    onChange={fieldhandleChange}
                                    value={state.memberpackageDetail.phone}
                                    InputProps={{
                                        inputComponent: TextMaskCustom
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    margin="dense"
                                    id="address1"
                                    name="address1"
                                    label="Address 1"
                                    type="text"
                                    onChange={fieldhandleChange}
                                    fullWidth={true}
                                    value={state.memberpackageDetail.address1}
                                    className={displayclass}
                                    error={errorstate.initialerrorstate.address1.errorstate}
                                    helperText={errorstate.initialerrorstate.address1.errortext}
                                    inputProps={{ maxLength: AddPersonAddress1Length }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    margin="dense"
                                    id="address2"
                                    name="address2"
                                    label="Address 2 (Optional)"
                                    type="text"
                                    fullWidth={true}
                                    onChange={fieldhandleChange}
                                    value={state.memberpackageDetail.address2}
                                    className={displayclass}
                                    inputProps={{ maxLength: AddPersonAddress2Length }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                {/* <TextField
                                    margin="dense"
                                    fullWidth={true}
                                    id="country"
                                    name="country"
                                    label="Country"
                                    type="text"
                                    onChange={fieldhandleChange}
                                    value={state.memberpackageDetail.country}
                                    className={displayclass}
                                    error={errorstate.initialerrorstate.country.errorstate}
                                    helperText={errorstate.initialerrorstate.country.errortext}
                                    inputProps={{ maxLength: AddPersonCountryLength }}
                                /> */}

                                {countryandstates.length > 0 ?
                                    <FormControl className={classes.box100per} error={errorstate.initialerrorstate.country.errorstate}>

                                        <Autocomplete filterOptions={filterOptions}
                                            id="country"
                                            name="country"
                                            className={displayclass}
                                            options={countryandstates}
                                            fullWidth={true}
                                            onChange={onChangeCountry}
                                            autoHighlight
                                            getOptionLabel={(option) => {
                                                if (option.hasOwnProperty('Country')) {
                                                    return option.Country;
                                                }
                                                return option;
                                            }}
                                            value={state.memberpackageDetail.country}
                                            // defaultValue={countryandstates[0]}
                                            renderOption={(option) => (
                                                <>
                                                    <img
                                                        loading="lazy"
                                                        width="40"
                                                        src={`https://flagcdn.com/w40/${option.ISOCode}.png`}
                                                        srcSet={`https://flagcdn.com/w80/${option.ISOCode}.png 2x`}
                                                        alt=""
                                                        style={{ margin: "10px" }}
                                                    />
                                                    {` ${option.Country} `}</>
                                            )}

                                            style={{ width: "100%" }}
                                            renderInput={(params) =>
                                            (<TextField label="Country" variant='outlined' className={classes.clearButton}{...params}
                                            />
                                            )}

                                        />
                                        <FormHelperText>{errorstate.initialerrorstate.country.errortext}</FormHelperText>
                                    </FormControl>
                                    : ""}

                            </Grid>
                            <Grid item xs={6}>
                                {/* <TextField
                                    margin="dense"
                                    fullWidth={true}
                                    id="state"
                                    name="state"
                                    label="State"
                                    type="text"
                                    onChange={fieldhandleChange}
                                    value={state.memberpackageDetail.state}
                                    className={displayclass}
                                    error={errorstate.initialerrorstate.state.errorstate}
                                    helperText={errorstate.initialerrorstate.state.errortext}
                                    inputProps={{ maxLength: AddPersonStateLength }}
                                /> */}

                                {countryandstates.length > 0 ?
                                    <FormControl className={classes.box100per} error={errorstate.initialerrorstate.state.errorstate}>

                                        <Autocomplete filterOptions={filterOptions}
                                            id="state"
                                            name="state"
                                            className={displayclass}
                                            autoHighlight
                                            options={
                                                state.memberpackageDetail.country ? countryandstates.filter(
                                                    x => x.Country == state.memberpackageDetail.country).map(o => o.hasOwnProperty("Picklist") ? o.Picklist : [])[0]
                                                    : []
                                            }
                                            fullWidth={true}
                                            onChange={onChangeState}
                                            getOptionLabel={(option) => {
                                                if (option.hasOwnProperty('State')) {
                                                    return option.State;
                                                }
                                                return option;
                                            }}
                                            value={state.memberpackageDetail.state}
                                            style={{ width: "100%" }}
                                            renderInput={(params) =>
                                            (<TextField label="State" variant='outlined' className={classes.clearButton}{...params}
                                            />
                                            )}

                                        />
                                        <FormHelperText>{errorstate.initialerrorstate.state.errortext}</FormHelperText>
                                    </FormControl>
                                    : ""}
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    margin="dense"
                                    fullWidth={true}
                                    id="city"
                                    name="city"
                                    label="City"
                                    type="text"
                                    onChange={fieldhandleChange}
                                    value={state.memberpackageDetail.city}
                                    className={displayclass}
                                    error={errorstate.initialerrorstate.city.errorstate}
                                    helperText={errorstate.initialerrorstate.city.errortext}
                                    inputProps={{ maxLength: AddPersonCityLength }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    margin="dense"
                                    fullWidth={true}
                                    id="zipcode"
                                    name="zipcode"
                                    label="Zipcode"
                                    type="text"
                                    onChange={fieldhandleChange}
                                    value={state.memberpackageDetail.zipcode}
                                    className={displayclass}
                                    error={errorstate.initialerrorstate.zipcode.errorstate}
                                    helperText={errorstate.initialerrorstate.zipcode.errortext}
                                    inputProps={{ maxLength: AddPersonZipCodeLength }}
                                />
                            </Grid>
                        </Grid>

                    </form>

                    {/* Membership UDFs */}
                    <Grid container xs={12} style={{ marginTop: 30 }}>
                        <Grid item lg={12} sm={12} xs={12}>
                            {state.memberpackageDetail.membershipTypeID && state.memberpackageDetail.membershipTypeID > 0
                                && props.membershipPackage.hasOwnProperty("MembershipProducts") ? props.membershipPackage.MembershipProducts.map((membershipProduct) => {

                                    return membershipProduct.MembershipTypeID && membershipProduct.MembershipTypeID === state.memberpackageDetail.membershipTypeID ?
                                        <div key={membershipProduct.MembershipTypeID + "_" + state.memberpackageDetail.userNo}>
                                            <Grid item lg={12} sm={12} xs={12} spacing={1} >
                                                <MembershipUDF MembershipTypeID={membershipProduct.MembershipTypeID} userNo={state.memberpackageDetail.userNo} />
                                            </Grid>
                                        </div>
                                        : null
                                })
                                : null
                            }
                        </Grid>
                    </Grid>

                </DialogContent>
                <DialogActions style={{ marginRight: "50px", marginBottom: "3px" }}>
                    <Button className={classes.primarycolor} variant="contained" size="medium" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button className={classes.primarycolor} disabled={saveBtn} variant="contained" onClick={() => saveDialog()} size="medium" >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Add/Edit Person Dialog End */}


            {/* Confirmation Box Start*/}
            <DialogeBox open={confirmopen.dialogBox} title="Delete Person"
                message={confirmopen.deletemsg}
                button1text="Cancel"
                button1clickhandler={CancelPersonDelete}
                button2text="Yes"
                button2clickhandler={ConfirmDeletePerson}
            ></DialogeBox>
            {/* Confirmation Box Start*/}


        </div >
    );
};